import { useNextRouterContext } from "@faire/deprecated-retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { EmptyStateSections } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/EmptyStateSections";
import {
  ISearchSuggestionResponseKeys,
  ISuggestionEntry,
  ISuggestionEntryMixin,
  ITypedSuggestionEntry,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import { ISuggestionSections } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import { PillsWithImageRow } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/PillsWithImageRow";
import { R2MSection } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/R2MSection";
import { ResultDropdownHeader } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/ResultDropdownHeader";
import { ResultsDropdownSectionsWrapper } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Styled";
import { TypeaheadStateSections } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/TypeaheadStateSections";
import { useLinkPrefetch } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/useLinkPrefetch";
import { getSuggestionUrl } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/utils";
import { shouldShowSearchRecommendations } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/utils";
import {
  getContainerName,
  getSuggestionEventToken,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/utils";
import {
  ARROW_DOWN,
  ARROW_UP,
  getBrandsHeader,
  getRecentlyViewedHeader,
  getRecentSearchesHeader,
  getSectionIdMap,
  getSuggestedTermsHeader,
  getTopResultsHeader,
  getTrendingBrandsHeader,
  getTrendingSearchesHeader,
  KEY_EVENT_VALUE,
  RESULT_DROPDOWN_SVG_ICON_PROPS,
  RETURN_KEY,
  TAB_KEY,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/consts";
import { ImageSearchPill } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ImageSearchPill";
import { ResultsDropdownSectionWrapper } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownSectionWrapper";
import {
  buildEmptyStateSuggestionsSections,
  buildTypeaheadSuggestionsSections,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/suggestionSectionBuilders";
import { useSearchSuggestionsData } from "@faire/deprecated-retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsData";
import { useSearchSuggestionsUpdateRecentSearchesQueries } from "@faire/deprecated-retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsInvalidateRecentSearches";
import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import preloadLazySearchPage from "@faire/deprecated-retailer-visitor-shared/lib/lazyPreload_DO_NOT_RENAME/searchPage";
import {
  trackBrandClick,
  trackProductClick,
} from "@faire/deprecated-retailer-visitor-shared/services/Events";
import { assignSettingR2BAwardConfiguration } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingR2BAwardConfiguration";
import { useSettingEnableNLSSearch } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableNLSSearch";
import { Core } from "@faire/design-tokens";
import { Clock } from "@faire/slate/icons/Clock";
import { useMutation as useMutationDeleteRecentSearchQuery } from "@faire/web-api--source/endpoints/www/api/v2/search/suggestions/recent-query/query/delete-hooks";
import { trackSearchSuggestionClick } from "@faire/web-api--source/events/search/click/suggestion";
import { trackSearchSearchSuggestionLoadedView } from "@faire/web-api--source/events/search/view/searchSuggestionLoaded";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
import { route as searchRoute } from "@faire/web-api--source/routes/www/search";
import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { getWindow } from "@faire/web/common/globals/getWindow";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { isTouchDevice } from "@faire/web/common/isTouchDevice";
import {
  DEPRECATED_backwardsCompatibleValues,
  useStrictLocalization,
} from "@faire/web/common/localization/localize";
import { logError } from "@faire/web/common/logging";
import {
  TimingMarker,
  TimingPair,
} from "@faire/web/common/timings/TimingMarker";
import { trackEvent } from "@faire/web/common/trackEvent";
import { isRobot } from "@faire/web/common/user-agent/isRobot";
import { Chevron } from "@faire/web/slate/icons/foundation/Chevron";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { createToast } from "@faire/web/slate/Toast/Toast";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import styled from "styled-components";

export interface IResultsDropdownProps {
  query: string;
  suggestions: ISearchSuggestionResponse;
  dontShowSearch: () => void;
  startTimingMarker?: TimingMarker;
  parent: HTMLDivElement | null;
  searchElement?: HTMLElement | null;
  submit: (query: string, submittedUrl?: string, navigate?: boolean) => void;
  cancelSearch: () => void;
  loadTimingRef?: React.RefCallback<HTMLElement>;
  shouldEnableSuggestionsImpressionAllocationV2: boolean;
}

export const ResultsDropdown = (
  props: Omit<IResultsDropdownProps, "suggestions">
) => {
  const { searchSuggestionResponse, startTimingMarker, query } =
    useSearchSuggestionsData();

  return (
    <ResultsDropdownWithoutDataFetching
      {...props}
      suggestions={searchSuggestionResponse}
      startTimingMarker={startTimingMarker}
      query={query || props.query}
    />
  );
};

const ResultsDropdownWithoutDataFetching: React.FunctionComponent<
  IResultsDropdownProps
> = ({
  submit,
  parent,
  dontShowSearch,
  startTimingMarker,
  searchElement,
  cancelSearch,
  query,
  suggestions,
  shouldEnableSuggestionsImpressionAllocationV2,
}) => {
  const onDeleteRecentSearch =
    useSearchSuggestionsUpdateRecentSearchesQueries("delete");
  const { mutate: deleteRecentSearchQueryAsync } =
    useMutationDeleteRecentSearchQuery({
      onSuccess: (_, [deleteQuery]) => {
        onDeleteRecentSearch(deleteQuery);
      },
      onError: (error) => {
        logError(error);
        createToast(error.message, {
          variant: "destructive",
          timeout: "long",
        });
      },
    });
  const deleteRecentSearchQuery = useCallback(
    async (deleteQuery: string) => {
      deleteRecentSearchQueryAsync([encodeURIComponent(deleteQuery)]);
    },
    [deleteRecentSearchQueryAsync]
  );
  const viewport = useViewport();
  const { strictLocalize } = useStrictLocalization();
  const shouldShowNLSSearchSuggestions = useSettingEnableNLSSearch();
  const prevQuery = useRef<string | undefined>(undefined);
  const prevSuggestions = useRef<ISearchSuggestionResponse | undefined>(
    undefined
  );
  const [displaySeeAllResults, setDisplaySeeAllResults] = useState(false);
  const [selected, setSelected] = useState(-1);
  const parentRect = useRef(parent ? parent.getBoundingClientRect() : null);
  const currentIdx = useRef(0);
  const sectionIdMap = useRef<Record<string, string>>({});
  sectionIdMap.current = getSectionIdMap(strictLocalize);

  const { prefetch: nextPrefetch } = useNextRouterContext();
  const isLoggedIn = isLoggedInRetailer();
  const { prefetchUrl, clearLinkPrefetchTimeout } = useLinkPrefetch();

  // this is used to reset the dropdown to top
  const reference = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      prevSuggestions.current?.request_id !== suggestions.request_id &&
      startTimingMarker
    ) {
      const timingPair: TimingPair = {
        start: startTimingMarker,
      };
      trackSearchSearchSuggestionLoadedView(timingPair);
    }
  }, [startTimingMarker, suggestions.request_id]);

  useEffect(() => {
    if (viewport.isMobile) {
      if (prevQuery.current !== query) {
        reference.current?.scrollTo?.(0, 0);
      }
    }
  }, [query, viewport.isMobile]);

  useEffect(() => {
    prevQuery.current = query;
    prevSuggestions.current = suggestions;
  }, [query, suggestions]);

  const parsedSuggestions = useMemo(() => {
    if (!suggestions) {
      return {};
    }

    let sections: ISuggestionSections = {};
    if (query) {
      sections = buildTypeaheadSuggestionsSections(
        suggestions,
        strictLocalize,
        shouldEnableSuggestionsImpressionAllocationV2,
        viewport
      );

      const hasSuggestedTerms =
        (sections[getSuggestedTermsHeader(strictLocalize)]?.length ?? 0) > 1;
      const hasBrands =
        (sections[getBrandsHeader(strictLocalize)]?.length ?? 0) > 1;
      const hasTopResults =
        (sections[getTopResultsHeader(strictLocalize)]?.length ?? 0) > 1;
      setDisplaySeeAllResults(
        viewport.isMobile && (hasSuggestedTerms || hasBrands || hasTopResults)
      );
    } else {
      sections = buildEmptyStateSuggestionsSections(
        suggestions,
        strictLocalize,
        shouldShowNLSSearchSuggestions
      );
      setDisplaySeeAllResults(false);
    }
    return sections;
  }, [
    query,
    suggestions,
    shouldShowNLSSearchSuggestions,
    strictLocalize,
    viewport,
    shouldEnableSuggestionsImpressionAllocationV2,
  ]);

  const shouldShowR2B = useMemo(
    () => suggestions.show_r2_b_banner,
    [suggestions]
  );

  const entryCount = entryCountFromSuggestions(parsedSuggestions);

  const onSuggestionClicked = useCallback(
    (
      suggestion: ISuggestionEntry,
      navigate: boolean = true // whether to explicitly navigate to the suggestion url
    ) => {
      clearLinkPrefetchTimeout();
      // User selected an autocompleted search query (suggested terms & recent searches)
      if (suggestion.sectionName === getSuggestedTermsHeader(strictLocalize)) {
        trackEvent(`/clicked-suggestion/query/${suggestion.searchData.query}`);

        // User select Recent searches
        // have the same event track path as suggested term because old version is doing this
      } else if (
        suggestion.sectionName === getRecentSearchesHeader(strictLocalize)
      ) {
        trackEvent(`/clicked-suggestion/query/${suggestion.label}`);
        // User select trending searches
      } else if (
        suggestion.sectionName === getTrendingSearchesHeader(strictLocalize)
      ) {
        if (
          shouldShowSearchRecommendations(suggestions?.search_recommendations)
        ) {
          trackEvent(
            `/clicked-suggestion/query/v2/trending-searches/${suggestion.label}`
          );
        } else {
          trackEvent(
            `/clicked-suggestion/query/trending-searches/${suggestion.searchData}`
          );
        }
      } else if (
        suggestion.sectionName === getTrendingBrandsHeader(strictLocalize) ||
        suggestion.sectionName === getBrandsHeader(strictLocalize)
      ) {
        trackEvent(`/clicked-suggestion/brand/${suggestion.searchData.token}`);
        trackBrandClick(
          suggestion.searchData.token ?? "",
          "header_search",
          suggestions.request_id
        );
      } else if (
        suggestion.sectionName === getRecentlyViewedHeader(strictLocalize) ||
        suggestion.sectionName === getTopResultsHeader(strictLocalize)
      ) {
        trackEvent(
          suggestion.sectionName === getRecentlyViewedHeader(strictLocalize)
            ? `/clicked-suggestion/product/recently-viewed/${suggestion.searchData.token}`
            : `/clicked-suggestion/product/top-results/${suggestion.searchData.token}`
        );
        trackProductClick(
          suggestion.searchData.token ?? "",
          "header_search",
          suggestions.request_id
        );
      }

      submit(
        suggestion.searchData.query ?? "",
        getSuggestionUrl(suggestion.url),
        navigate
      );
    },
    [
      strictLocalize,
      submit,
      suggestions.request_id,
      suggestions?.search_recommendations,
      clearLinkPrefetchTimeout,
    ]
  );

  const isElementInContainer = useCallback(
    (element: HTMLElement) => {
      const {
        left: elementLeft,
        right: elementRight,
        top: elementTop,
      } = element.getBoundingClientRect();
      const {
        left: containerLeft,
        right: containerRight,
        top: containerTop,
      } = parentRect.current ?? { left: 0, right: 0, top: 0 };
      return (
        elementLeft >= containerLeft &&
        elementRight <= containerRight &&
        elementTop >= containerTop
      );
    },
    [parentRect]
  );

  const handleSuggestionBlur = useCallback(() => {
    clearLinkPrefetchTimeout();
  }, [clearLinkPrefetchTimeout]);

  const handleSuggestionHover = useCallback(
    (selectedIdx: number, url?: string) => {
      if (selectedIdx < 0) {
        setSelected(-1);
        return;
      }
      if (selectedIdx >= entryCount) {
        setSelected(entryCount - 1);
      } else {
        setSelected(selectedIdx);
      }
      if (isLoggedIn) {
        prefetchUrl(url);
      }
    },
    [entryCount, isLoggedIn, prefetchUrl]
  );

  const onReturnPressed = useCallback(() => {
    if (selected >= 0) {
      const allSuggestions = Object.values(parsedSuggestions).reduce(
        (result: ISuggestionEntry[], array: ISuggestionEntry[]) => [
          ...result,
          ...array,
        ],
        []
      );
      const currentSelection = allSuggestions[selected];

      if (currentSelection) {
        onSuggestionClicked(currentSelection);
      }
    } else if (query) {
      submit(query);
    }

    if (searchElement) {
      searchElement.blur();
    }
  }, [
    selected,
    query,
    searchElement,
    parsedSuggestions,
    onSuggestionClicked,
    submit,
  ]);

  const keyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.type !== KEY_EVENT_VALUE) {
        return;
      }

      if (
        event.keyCode !== ARROW_UP &&
        event.keyCode !== ARROW_DOWN &&
        event.keyCode !== RETURN_KEY &&
        event.keyCode !== TAB_KEY
      ) {
        return;
      }

      // The parent search bar is also handling RETURN_KEY to execute searches.
      // So stop propagation in cases of hitting RETURN on a suggestion.
      event.stopPropagation();

      switch (event.keyCode) {
        case ARROW_UP:
          event.preventDefault();
          handleSuggestionBlur();
          handleSuggestionHover(selected - 1);
          break;

        case ARROW_DOWN:
          event.preventDefault();
          handleSuggestionBlur();
          handleSuggestionHover(selected + 1);
          break;

        case RETURN_KEY:
          onReturnPressed();
          break;

        case TAB_KEY:
          if (!isElementInContainer(event.target as HTMLElement)) {
            dontShowSearch();
          }
          break;

        default:
          break;
      }
    },
    [
      dontShowSearch,
      isElementInContainer,
      onReturnPressed,
      selected,
      handleSuggestionHover,
      handleSuggestionBlur,
    ]
  );

  // splitting up the useeffect
  useEffect(() => {
    assignSettingR2BAwardConfiguration();
    if (getGlobalProperty("isNextJS", false) && !isRobot()) {
      nextPrefetch(searchRoute);
    } else {
      preloadLazySearchPage();
    }
  }, [nextPrefetch]);

  useEffect(() => {
    getWindow()?.addEventListener(KEY_EVENT_VALUE, keyDown, {
      capture: true,
    });

    return () => {
      getWindow()?.removeEventListener(KEY_EVENT_VALUE, keyDown, {
        capture: true,
      });
      if (isTouchDevice() && viewport.isMobile) {
        getWindow()?.removeEventListener(
          "touchstart",
          removeFocusOnTopSearchWhenTouchStart,
          {
            capture: true,
          }
        );
      }
    };
  }, [keyDown, viewport.isMobile]);

  useEffect(() => {
    parentRect.current = parent ? parent.getBoundingClientRect() : null;
  }, [parent]);

  useEffect(() => {
    if (isTouchDevice() && viewport.isMobile) {
      getWindow()?.addEventListener(
        "touchstart",
        removeFocusOnTopSearchWhenTouchStart,
        {
          capture: true,
        }
      );
    }
  }, [viewport.isMobile]);

  const haveSuggestions = () => entryCount > 0;

  const buildTrendingSearchImageItem = useCallback(
    (suggestion: ISuggestionEntry) => {
      const indx = currentIdx.current++;

      return (
        <ImageSearchPill
          key={suggestion.url + indx.toString()}
          selected={indx === selected}
          onHover={() => handleSuggestionHover(indx, suggestion.url)}
          onMouseLeave={() => {
            handleSuggestionBlur();
            handleSuggestionHover(-1);
          }}
          onClick={() => onSuggestionClicked(suggestion, false)}
          suggestion={suggestion}
          url={getSuggestionUrl(suggestion.url)}
          dataTestId="search-recommendation-pill"
        />
      );
    },
    [selected, handleSuggestionHover, handleSuggestionBlur, onSuggestionClicked]
  );

  const buildRecentSearchesImageItem = useCallback(
    (suggestion: ISuggestionEntry) => {
      const indx = currentIdx.current++;

      return (
        <ImageSearchPill
          key={suggestion.url + indx.toString()}
          onHover={() => handleSuggestionHover(indx, suggestion.url)}
          onMouseLeave={() => {
            handleSuggestionBlur();
            handleSuggestionHover(-1);
          }}
          onClick={() => onSuggestionClicked(suggestion, false)}
          onDelete={() => deleteRecentSearchQuery(suggestion.label)}
          suggestion={suggestion}
          selected={indx === selected}
          svgIcon={<Clock {...RESULT_DROPDOWN_SVG_ICON_PROPS} />}
          url={getSuggestionUrl(suggestion.url)}
          dataTestId="recent-search-recommendation-pill"
        />
      );
    },
    [
      selected,
      handleSuggestionHover,
      handleSuggestionBlur,
      onSuggestionClicked,
      deleteRecentSearchQuery,
    ]
  );

  const trackClick = useCallback(
    (
      sectionHeader: string,
      sectionIndex: number,
      suggestion: ISuggestionEntry,
      suggestionIndex: number,
      navigate: boolean = true
    ): void => {
      const requestId = suggestion.requestID;

      const suggestionEventToken = getSuggestionEventToken(
        sectionHeader,
        suggestion,
        strictLocalize
      );

      if (suggestionEventToken !== undefined) {
        const containerName = getContainerName(sectionHeader, strictLocalize);
        const token = `${query}|${suggestionEventToken}|${suggestionIndex}`;

        trackSearchSuggestionClick(
          `${containerName}|${sectionIndex}`,
          requestId ?? "",
          token
        );
      }

      /**
       * Perform legacy event tracking.
       * We will eventually refactor all of the legacy event tracking with PETE.
       */
      onSuggestionClicked(suggestion, navigate);
    },
    [onSuggestionClicked, query, strictLocalize]
  );

  const renderDropdownSection = useCallback(
    (
      sectionHeader: string,
      suggestionArray:
        | ISuggestionEntry[]
        | ITypedSuggestionEntry<ISearchSuggestionResponseKeys>[],
      sectionIndex: number
    ) => {
      // Check to see if search recommendations is returned
      if (viewport.isTabletAndAbove) {
        if (
          sectionHeader === getTrendingSearchesHeader(strictLocalize) &&
          shouldShowSearchRecommendations(suggestions?.search_recommendations)
        ) {
          return (
            <PillsWithImageRow
              sectionHeader={sectionHeader}
              suggestionArray={suggestionArray}
              query={query}
              sectionIndex={sectionIndex}
              buildTrendingSearchImageItem={buildTrendingSearchImageItem}
            />
          );
        }

        if (sectionHeader === getRecentSearchesHeader(strictLocalize)) {
          return (
            <PillsWithImageRow
              sectionHeader={sectionHeader}
              suggestionArray={suggestionArray}
              query={query}
              sectionIndex={sectionIndex}
              buildRecentSearchesImageItem={buildRecentSearchesImageItem}
            />
          );
        }
      }

      return (
        <ResultsDropdownSectionWrapper
          sectionHeader={sectionHeader}
          suggestionArray={suggestionArray}
          sectionIndex={sectionIndex}
          query={query}
        >
          {suggestionArray.map(
            (suggestion: ISuggestionEntryMixin, suggestionIndex: number) => {
              const trackClickCallback = () =>
                trackClick(
                  sectionHeader,
                  sectionIndex,
                  suggestion,
                  suggestionIndex,
                  false
                );
              const indx = currentIdx.current++;

              if (query) {
                return (
                  <TypeaheadStateSections
                    key={suggestion.url + indx.toString()}
                    sectionHeader={sectionHeader}
                    suggestion={suggestion}
                    onHover={handleSuggestionHover}
                    onMouseLeave={handleSuggestionBlur}
                    onClick={trackClickCallback}
                    selected={selected}
                    indx={indx}
                    shouldEnableSuggestionsImpressionAllocationV2={
                      shouldEnableSuggestionsImpressionAllocationV2
                    }
                    query={query}
                  />
                );
              }

              return (
                <EmptyStateSections
                  key={suggestion.url + indx.toString()}
                  sectionHeader={sectionHeader}
                  suggestion={suggestion}
                  onHover={() => handleSuggestionHover(indx, suggestion.url)}
                  onMouseLeave={handleSuggestionBlur}
                  onClick={trackClickCallback}
                  onDelete={() => deleteRecentSearchQuery(suggestion.label)}
                  selected={selected}
                  indx={indx}
                  shouldEnableSuggestionsImpressionAllocationV2={
                    shouldEnableSuggestionsImpressionAllocationV2
                  }
                />
              );
            }
          )}
        </ResultsDropdownSectionWrapper>
      );
    },
    [
      strictLocalize,
      suggestions?.search_recommendations,
      viewport.isTabletAndAbove,
      trackClick,
      query,
      buildRecentSearchesImageItem,
      buildTrendingSearchImageItem,
      selected,
      deleteRecentSearchQuery,
      shouldEnableSuggestionsImpressionAllocationV2,
      handleSuggestionHover,
      handleSuggestionBlur,
    ]
  );

  const buildDropdownSections = useCallback(
    (
      sectionHeader: string,
      suggestionArray:
        | ISuggestionEntry[]
        | ITypedSuggestionEntry<ISearchSuggestionResponseKeys>[],
      sectionIndex: number
    ) => {
      const shouldShowSectionHeader =
        sectionHeader &&
        sectionHeader !== getSuggestedTermsHeader(strictLocalize);

      return (
        <ResultsDropdownSectionsWrapper
          key={sectionHeader + sectionIndex.toString()}
        >
          {shouldShowSectionHeader ? (
            <ResultDropdownHeader sectionHeader={sectionHeader} />
          ) : null}
          <div>
            {renderDropdownSection(
              sectionHeader,
              suggestionArray,
              sectionIndex
            )}
          </div>
        </ResultsDropdownSectionsWrapper>
      );
    },
    [strictLocalize, renderDropdownSection]
  );

  const contents = useMemo(() => {
    currentIdx.current = 0;
    return Object.entries(parsedSuggestions)
      .filter(
        ([_, suggestions]: [string, ISuggestionEntryMixin[]]) =>
          suggestions.length > 0
      )
      .map(
        (
          [sectionHeader, suggestions]: [string, ISuggestionEntryMixin[]],
          sectionIndex: number
        ) => buildDropdownSections(sectionHeader, suggestions, sectionIndex)
      );
  }, [buildDropdownSections, parsedSuggestions]);

  if (!haveSuggestions()) {
    return null;
  }

  return (
    <>
      {contents}
      {displaySeeAllResults ? (
        <AllResultWrapper onClick={() => submit(query)}>
          <StrictLocalMsg
            id="4dmMpz"
            defaultMessage={'See all results for "{query}"'}
            values={DEPRECATED_backwardsCompatibleValues({
              query: query,
            })}
          />
          <Chevron
            width="10px"
            strokeWidth="2.5px"
            direction="right"
            stroke={Core.icon.subdued}
          />
        </AllResultWrapper>
      ) : null}
      {!isLoggedIn ? <Spacer height={25} /> : null}
      {isLoggedIn && shouldShowR2B ? (
        <R2MSection
          onClick={() => cancelSearch()}
          onMouseOver={() => handleSuggestionHover(-1)}
          onMouseLeave={handleSuggestionBlur}
        />
      ) : (
        <Spacer height="2x" />
      )}
      {viewport.isMobile ? <Spacer height={100} /> : null}
    </>
  );
};

const entryCountFromSuggestions = (
  suggestions: ISuggestionSections
): number => {
  let total = 0;
  Object.values(suggestions).forEach((suggestion) => {
    total += suggestion.length;
  });
  return total;
};

const removeFocusOnTopSearchWhenTouchStart = () => {
  const topSearchElement = getDocumentOrThrow().getElementById("top-search");
  topSearchElement?.blur();
};

const AllResultWrapper = styled(Row).attrs({
  justify: "space-between",
  align: "center",
})`
  position: relative;
  height: 64px;
  padding: 22px 16px 23px 19px;
`;
